import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path d="M8.354,0.146l2.5,2.5C10.951,2.744,11,2.872,11,3s-0.049,0.256-0.146,0.354c-0.196,0.195-0.513,0.195-0.708,0 L8.5,1.707V10.5C8.5,10.776,8.277,11,8,11c-0.276,0-0.5-0.224-0.5-0.5V1.707L5.854,3.354c-0.196,0.195-0.512,0.195-0.708,0 c-0.195-0.196-0.195-0.512,0-0.708l2.5-2.5C7.843-0.049,8.159-0.049,8.354,0.146z" />
			<path d="M4.5,6C4.776,6,5,6.224,5,6.5S4.776,7,4.5,7h-1C3.224,7,3,7.224,3,7.5v7C3,14.775,3.224,15,3.5,15h9 c0.275,0,0.5-0.225,0.5-0.5v-7C13,7.224,12.775,7,12.5,7h-1C11.224,7,11,6.776,11,6.5S11.224,6,11.5,6h1C13.327,6,14,6.673,14,7.5v7 c0,0.827-0.673,1.5-1.5,1.5h-9C2.673,16,2,15.327,2,14.5v-7C2,6.673,2.673,6,3.5,6H4.5z" />
		</svg>
	);
};
